"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![RedoIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE3IDUuOTEiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5SZWRvPC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2LjYyLjUyQS41LjUsMCwwLDAsMTYsLjg4TDE1LjIyLDRBOC42NSw4LjY1LDAsMCwwLC4wNSw1YS41LjUsMCwwLDAsLjI0LjY3LjUyLjUyLDAsMCwwLC4yMSwwQS40OC40OCwwLDAsMCwxLDUuNDUsNy42Nyw3LjY3LDAsMCwxLDExLjEyLDEuNzEsNy41Nyw3LjU3LDAsMCwxLDE0LjQsNC42NGwtMy4yOS0uODJhLjUuNSwwLDAsMC0uNjEuMzYuNTEuNTEsMCwwLDAsLjM3LjYxbDQuNCwxLjEuMTMsMGEuNS41LDAsMCwwLC40OC0uMzhMMTcsMS4xMkEuNS41LDAsMCwwLDE2LjYyLjUyWiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.RedoIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 17 5.91", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M16.62.52a.5.5 0 0 0-.62.36L15.22 4A8.65 8.65 0 0 0 .05 5a.5.5 0 0 0 .24.67.52.52 0 0 0 .21 0 .48.48 0 0 0 .5-.22 7.67 7.67 0 0 1 10.12-3.74 7.57 7.57 0 0 1 3.28 2.93l-3.29-.82a.5.5 0 0 0-.61.36.51.51 0 0 0 .37.61l4.4 1.1h.13a.5.5 0 0 0 .48-.38L17 1.12a.5.5 0 0 0-.38-.6z" })));
};
//# sourceMappingURL=Icon.Redo.js.map